import {combineReducers}  from "redux"
import {Templates}        from "./Templates"

export const Reports = combineReducers({
  Templates,
})
